// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import mainSlider from './js/widgets/mainSlider.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import masonryCards from './js/widgets/masonryCards.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import hotButtons from './js/widgets/hotButtons.js';
import galleryWidget from './js/widgets/galleryWidget.js';
import sponsorsManaged from './js/widgets/sponsorsManaged.js';
import sponsors from './js/widgets/sponsors.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (globalThis.location.pathname === '/') {
  $(document).ready(function () {
    mainSlider();
    eventsWidget();
    masonryCards('twoCardsWidget', twoCardsWidgetOpts, 2);
    masonryCards('fourCardsWidget', fourCardsWidgetOpts, 4);
    seoWidget();
    videoWidget();
    hotButtons();
    galleryWidget();
    sponsorsManaged();
    sponsors();
  });
}

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();
});
